import React, { useEffect, useState } from 'react';
import SaveIcon from '@material-ui/icons/Save';
import CloseIcon from '@material-ui/icons/Close';
import { Formik, Form, yupToFormErrors } from 'formik';
import * as Yup from 'yup';
import { Grid } from '@material-ui/core';
import BiztranControls from "../../biztran_controls/BiztranControls";
import BiztranControlsFormik from "../../biztran_controls_formik/BiztranControlsFormik";
import UseFetchData from "../../../hooks/UseFetchData";
import ImageAttachment from "../../biztran_controls/ImageAttachment";

const CreateProductSKU = (props) => {
    //const [ProductSKUID, setProductSKUID] = useState();
    const [ProductID, setProductID] = useState();
    const [ProductName, setProductName] = useState('');
    const [ModelCode, setModelCode] = useState('');
    const [Description, setDescription] = useState('');
    const [Specifications, setSpecifications] = useState('');
    const [DisableProductCat1, setDisableProductCat1] = useState(false);
    const [DisableProductCat2, setDisableProductCat2] = useState(false);
    const [ProductCat1ID, setProductCat1ID] = useState('');
    const [ProductCat2ID, setProductCat2ID] = useState('');
    const [ProductCat3ID, setProductCat3ID] = useState('');
    const [ProductCat4ID, setProductCat4ID] = useState('');
    const [UnitID, setUnitID] = useState("944C3E90-8F64-40BF-97C7-6BB66F67CEE0");
    const [GstPer, setGstPer] = useState(18);
    const [HSNCode, setHSNCode] = useState('');
    // const [ConversionRate, setConversionRate] = useState("");
    // const [MandrelSpareModelID, setMandrelSpareModelID] = useState('');
    // const [RollerSetSpareModelID, setRollerSetSpareModelID] = useState('');
    const [ShippingWeight, setShippingWeight] = useState('');
    const [ListPriceINR, setListPriceINR] = useState(1);
    const [ListPriceUSD, setListPriceUSD] = useState(1);
    const [Weight_kg, setWeight_kg] = useState(0);
    // const [Weight_lbs, setWeight_lbs] = useState('');
    //const [Productcmb, setProductcmb] = useState('');
    const [ProductCat1cmb, setProductCat1cmb] = useState([]);
    const [ProductCat2cmb, setProductCat2cmb] = useState([]);
    const [ProductCat3cmb, setProductCat3cmb] = useState([]);
    const [ProductCat4cmb, setProductCat4cmb] = useState([]);
    const [Unitcmb, setUnitcmb] = useState([]);
    const [HSNcmb, setHSNcmb] = useState([]);
    // const [ConversionResopnse, fetchConversion] = UseFetchData();
    // const [MandrelSpareModelcmb, setMandrelSpareModelcmb] = useState([]);
    // const [RollerSetSpareModelcmb, setRollerSetSpareModelcmb] = useState([]);
    const [response, fetchData] = UseFetchData();
    const [responseCmbData, fetchComboData] = UseFetchData();
    const [responseGetData, fetchDataGetData] = UseFetchData();

    const validationSchema = Yup.object({
        ProductName: Yup.string().required('Required!'),
        ModelCode: Yup.string().required('Required!'),
        Weight_kg: Yup.string().required('Required!'),
        GstPer: Yup.string().required('Required!'),
        ShippingWeight: Yup.number().min(0),
        ListPriceINR: Yup.number().min(0),
        ListPriceUSD: Yup.number().min(0),
        // UnitID: Yup.number().required('Required!'),
    });


    const onSubmit = values => {
        // debugger;
        var bodyFormData = new FormData();
        bodyFormData.append("ProductSKUID", props.ProductSKUID);
        bodyFormData.append("ProductID", props.ProductID);
        bodyFormData.append("ProductName", values.ProductName);
        bodyFormData.append("ModelCode", values.ModelCode);
        bodyFormData.append("Description", values.Description);
        bodyFormData.append("Specifications", values.Specifications);
        bodyFormData.append("ProductCat1ID", values.ProductCat1ID);
        bodyFormData.append("ProductCat2ID", values.ProductCat2ID);
        bodyFormData.append("ProductCat3ID", values.ProductCat3ID);
        bodyFormData.append("ProductCat4ID", values.ProductCat4ID);
        bodyFormData.append("UnitID", values.UnitID);
        bodyFormData.append("GstPer", values.GstPer);
        bodyFormData.append("HSNCode", values.HSNCode);
        // bodyFormData.append("ConversionRate", parseFloat(ConversionRate));
        // bodyFormData.append("MandrelSpareModelID", values.MandrelSpareModelID);
        // bodyFormData.append("RollerSetSpareModelID", values.RollerSetSpareModelID);
        bodyFormData.append("ShippingWeight", values.ShippingWeight);
        bodyFormData.append("ListPriceINR", values.ListPriceINR);
        bodyFormData.append("ListPriceUSD", values.ListPriceUSD);
        bodyFormData.append("Weight_kg", values.Weight_kg);
        // bodyFormData.append("Weight_lbs", values.Weight_lbs);
        fetchData("ProductSKU/save", bodyFormData);
    };


    const GetComboData = () => {
        var bodyFormData = new FormData();
        bodyFormData.append("ProductID", props.ProductID);
        fetchComboData("ProductSKU/ComboData", bodyFormData);
    };



    useEffect(() => {
        // debugger;
        if (sessionStorage.UID == '101B316C-5D92-4066-82AB-35741EE773F8' || sessionStorage.UserType == "Admin") {

            setDisableProductCat1(false);
            setDisableProductCat2(false);
        }
        else {

            setDisableProductCat1(true);
            setDisableProductCat2(true);
        }

    });

    const ProductCat1Data = (options) => {
        if (options !== undefined) {
            let ProductCat1 = options.map((data) =>
                <option
                    key={data.ProductCat1}
                    value={data.ProductCat1ID}
                >
                    {data.ProductCat1}
                </option>
            );
            setProductCat1cmb(ProductCat1)
        }
    }

    const HSNcodeData = (options) => {
        if (options !== undefined) {
            let HSNCode = options.map((data) =>
                <option
                    key={data.HSNCode}
                    value={data.HSNCode}
                >
                    {data.HSNCode}
                </option>
            );
            setHSNcmb(HSNCode)
        }
    }

    const ProductCat2Data = (options) => {
        if (options !== undefined) {
            let ProductCat2 = options.map((data) =>
                <option
                    key={data.ProductCat2}
                    value={data.ProductCat2ID}
                >
                    {data.ProductCat2}
                </option>
            );
            setProductCat2cmb(ProductCat2)
        }
    }

    const ProductCat3Data = (options) => {
        if (options !== undefined) {
            let ProductCat3 = options.map((data) =>
                <option
                    key={data.ProductCat3}
                    value={data.ProductCat3ID}
                >
                    {data.ProductCat3}
                </option>
            );
            setProductCat3cmb(ProductCat3)
        }
    }

    const ProductCat4Data = (options) => {
        if (options !== undefined) {
            let ProductCat4 = options.map((data) =>
                <option
                    key={data.ProductCat4}
                    value={data.ProductCat4ID}
                >
                    {data.ProductCat4}
                </option>
            );
            setProductCat4cmb(ProductCat4)
        }
    }

    const UnitData = (options) => {
        if (options !== undefined) {
            let Unit = options.map((data) =>
                <option
                    key={data.Unit}
                    value={data.UnitID}
                >
                    {data.Unit}
                </option>
            );
            setUnitcmb(Unit)
        }
    }

    // const MandrelSpareModelData = (options) => {
    //     if (options !== undefined) {
    //         let MandrelSpareModel = options.map((data) =>
    //             <option
    //                 key={data.MandrelSpareModel}
    //                 value={data.MandrelSpareModelID}
    //             >
    //                 {data.MandrelSpareModel}
    //             </option>
    //         );
    //         setMandrelSpareModelcmb(MandrelSpareModel)
    //     }
    // }

    // const RollerSetSpareModelData = (options) => {
    //     if (options !== undefined) {
    //         let RollerSetSpareModel = options.map((data) =>
    //             <option
    //                 key={data.RollerSetSpareModel}
    //                 value={data.RollerSetSpareModelID}
    //             >
    //                 {data.RollerSetSpareModel}
    //             </option>
    //         );
    //         setRollerSetSpareModelcmb(RollerSetSpareModel)
    //     }
    // }



    const GetByIDData = () => {
        var bodyFormData = new FormData();
        bodyFormData.append("ProductSKUID", props.ProductSKUID);
        fetchDataGetData("productSKU/GetByID", bodyFormData);
    }

    useEffect(() => {
        if (responseGetData !== undefined && responseGetData.length > 0) {
            setProductName(responseGetData[0].ProductName);
            setModelCode(responseGetData[0].ModelCode);
            setDescription((responseGetData[0].Description) === null ? "" : responseGetData[0].Description);
            setSpecifications((responseGetData[0].Specifications) === null ? "" : responseGetData[0].Specifications);
            setProductCat2ID((responseGetData[0].ProductCat2ID === null) ? "" : responseGetData[0].ProductCat2ID);
            setProductCat3ID((responseGetData[0].ProductCat3ID === null) ? "" : responseGetData[0].ProductCat3ID);
            setProductCat4ID((responseGetData[0].ProductCat4ID === null) ? "" : responseGetData[0].ProductCat4ID);
            setProductCat1ID((responseGetData[0].ProductCat1ID === null) ? "" : responseGetData[0].ProductCat1ID);
            setUnitID((responseGetData[0].UnitID === null) ? "" : responseGetData[0].UnitID);
            setGstPer((responseGetData[0].GstPer === null) ? "" : responseGetData[0].GstPer);
            setHSNCode((responseGetData[0].HSNCode === null) ? "" : responseGetData[0].HSNCode);
            // setMandrelSpareModelID((responseGetData[0].MandrelSpareModelID === null) ? "" : responseGetData[0].MandrelSpareModelID);
            // setRollerSetSpareModelID((responseGetData[0].RollerSetSpareModelID === null) ? "" : responseGetData[0].RollerSetSpareModelID);
            // debugger;
            setShippingWeight(responseGetData[0].ShippingWeight);
            setListPriceINR((responseGetData[0].ListPriceINR === null) ? "0" : responseGetData[0].ListPriceINR);
            setListPriceUSD((responseGetData[0].ListPriceUSD === null) ? "0" : responseGetData[0].ListPriceUSD);
            setWeight_kg((responseGetData[0].Weight_kg === null) ? "0" : responseGetData[0].Weight_kg);
            // setWeight_lbs((responseGetData[0].Weight_lbs === null) ? "0" : responseGetData[0].Weight_lbs);
        }
    }, [responseGetData]);

    useEffect(() => {
        // debugger;
        if (response.Response === true) {
            props.setOpen(false);
            props.PopulateData();
            alert('Saved Succesfully.')
        }
        else if (response.Response === false) {
            if (response.Message.includes('Already') === true) {
                alert(response.Message);
            }
            else {
                alert('Failed.');
            }
            // alert('Save Failed.')
        }
    }, [response])



    useEffect(() => {
        if (responseCmbData !== undefined) {
            if (responseCmbData["ProductCat1"] !== undefined
                && responseCmbData["ProductCat2"] !== undefined
                && responseCmbData["ProductCat3"] !== undefined
                && responseCmbData["ProductCat4"] !== undefined
                && responseCmbData["Unit"] !== undefined
                && responseCmbData["HSNCode"] !== undefined
            ) {
                ProductCat1Data(responseCmbData["ProductCat1"]);
                ProductCat2Data(responseCmbData["ProductCat2"]);
                ProductCat3Data(responseCmbData["ProductCat3"]);
                ProductCat4Data(responseCmbData["ProductCat4"]);
                UnitData(responseCmbData["Unit"]);
                HSNcodeData(responseCmbData["HSNCode"]);
                // MandrelSpareModelData(responseCmbData["MandrelSpareModel"]);
                // RollerSetSpareModelData(responseCmbData["RollerSetSpareModel"]);
            }
        }
    }, [responseCmbData]);

    useEffect(() => {
        GetComboData();
        // GetConversionDate();
        setProductID(props.ProductID);
        if (props.ProductSKUID !== "" && props.Mode === "Update") {
            GetByIDData();
        }
    }, []);

    return (
        <div>
            <Formik initialValues={{
                ProductID: ProductID, ProductName: props.ProductName, ModelCode: ModelCode, Description: Description, ProductCat1ID: ProductCat1ID, ProductCat2ID: ProductCat2ID, ProductCat3ID: ProductCat3ID
                , ProductCat4ID: ProductCat4ID, HSNCode: HSNCode, UnitID: UnitID, GstPer: GstPer, ShippingWeight: ShippingWeight, ListPriceINR: ListPriceINR
                , ListPriceUSD: ListPriceUSD, Specifications: Specifications, Weight_kg: Weight_kg
            }}
                validationSchema={validationSchema} onSubmit={onSubmit} enableReinitialize>
                {formik => {
                    return <Form>
                        <Grid container spacing={2}>
                            <Grid item xs={12} sm container>
                                <Grid item xs container direction="column" spacing={2}>
                                    <Grid item xs>
                                        <Grid item xs={12} container direction="row" spacing={1}>
                                            <Grid item xs={6}>
                                                <BiztranControlsFormik
                                                    control='input'
                                                    type='text'
                                                    label='Product'
                                                    name='ProductName'
                                                    disabled={true}
                                                    value={String(props.ProductName)}
                                                />
                                            </Grid>
                                            <Grid item xs={6}>
                                                <BiztranControlsFormik
                                                    control='input'
                                                    type='text'
                                                    label='Model Code'
                                                    name='ModelCode'
                                                    onChange={(e) => setModelCode(e.target.value)}
                                                />
                                            </Grid>
                                        </Grid>
                                        <Grid item xs={12}>
                                            <BiztranControlsFormik
                                                control='textarea'
                                                type='text'
                                                label='Description'
                                                name='Description'
                                                height='90px'
                                                onChange={(e) => setDescription(e.target.value)}
                                            />
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid item >
                                <ImageAttachment
                                    id="productsku-img-btn"
                                    Group="ProductSKU"
                                    Type="Image"
                                    RefDocumentID={props.ProductSKUID}
                                />
                            </Grid>
                        </Grid>
                        <Grid spacing={2} container direction="row">
                            <Grid item xs={12}>
                                <BiztranControlsFormik
                                    control='textarea'
                                    type='text'
                                    label='Specifications'
                                    name='Specifications'
                                    height='120px'
                                    onChange={(e) => setSpecifications(e.target.value)}
                                />
                            </Grid>
                            <Grid item xs={6}>
                                {/* <BiztranControlsFormik
                                    control='select'
                                    label='Product Cat 1'
                                    name='ProductCat1ID'
                                    disabled={DisableProductCat1}
                                    options={ProductCat1cmb}
                                    onChange={(e) => setProductCat1ID(e.target.value)}

                                /> */}
                                <BiztranControlsFormik
                                    control='select'
                                    label='Product Cat 1'
                                    name='ProductCat1ID'
                                    disabled={DisableProductCat1}
                                    options={ProductCat1cmb}
                                    onChange={(e) => setProductCat1ID(e.target.value)}
                                />
                            </Grid>
                            <Grid item xs={6}>
                                <BiztranControlsFormik
                                    control='select'
                                    label='Product Cat 2'
                                    name='ProductCat2ID'
                                    disabled={DisableProductCat2}
                                    options={ProductCat2cmb}
                                    onChange={(e) => setProductCat2ID(e.target.value)}

                                />
                            </Grid>
                            <Grid item xs={6}>
                                <BiztranControlsFormik
                                    control='select'
                                    label='Product Cat 3'
                                    name='ProductCat3ID'
                                    options={ProductCat3cmb}
                                    onChange={(e) => setProductCat3ID(e.target.value)}

                                />
                            </Grid>
                            <Grid item xs={6}>
                                <BiztranControlsFormik
                                    control='select'
                                    label='Product Cat 4'
                                    name='ProductCat4ID'
                                    options={ProductCat4cmb}
                                    onChange={(e) => setProductCat4ID(e.target.value)}
                                />
                            </Grid>
                            <Grid item xs={6}>
                                <BiztranControlsFormik
                                    control='select'
                                    name='UnitID'
                                    label='Unit'
                                    options={Unitcmb}
                                    onChange={(e) => setUnitID(e.target.value)}
                                />
                                {/* <BiztranControlsFormik
                                    control='select'
                                    label='Unit'
                                    name='UnitID'
                                    options={Unitcmb}
                                    onChange={(e) => setUnitID(e.target.value)}
                                /> */}
                            </Grid>
                            {/* <Grid item xs={6}>
                                <BiztranControlsFormik
                                    control='input'
                                    type='text'
                                    label='SGSTPer'
                                    name='GstPer'
                                    onChange={(e) => setGstPer(e.target.value)}
                                />
                            </Grid> */}
                            <Grid item xs={6}>
                                <BiztranControlsFormik
                                    control='input'
                                    type='text'
                                    label='GSTPer'
                                    name='GstPer'
                                    disabled={true}
                                    onChange={(e) => setGstPer(e.target.value)}
                                />
                            </Grid>
                            {/* <Grid item xs={6}>
                                <BiztranControlsFormik
                                    control='input'
                                    type='text'
                                    label='IGSTPer'
                                    name='GstPer'
                                    onChange={(e) => setGstPer(e.target.value)}
                                />
                            </Grid> */}
                            <Grid item xs={6}>
                                <BiztranControlsFormik
                                    control='input'
                                    type='text'
                                    label='Shipping Weight'
                                    name='ShippingWeight'
                                    onChange={(e) => setShippingWeight(e.target.value)}
                                />
                            </Grid>
                            <Grid item xs={6} style={{ marginTop: 20 }}>
                                {/* <BiztranControlsFormik
                                    control='input'
                                    type='text'
                                    label='HSNCode'
                                    name='HSNCode'
                                    onChange={(e) => setHSNCode(e.target.value)}
                                /> */}
                                <BiztranControlsFormik
                                    control='select'
                                    type='text'
                                    name='HSNCode'
                                    options={HSNcmb}
                                    onChange={(e) => setHSNCode(e.target.value)}
                                />
                            </Grid>
                            <Grid item xs={6}>
                                <BiztranControlsFormik
                                    control='input'
                                    type='text'
                                    label='List Price(INR)'
                                    name='ListPriceINR'
                                    onChange={(e) => setListPriceINR(e.target.value)}

                                />
                            </Grid>
                            <Grid item xs={6}>
                                <BiztranControlsFormik
                                    control='input'
                                    type='text'
                                    label='List Price(USD)'
                                    name='ListPriceUSD'
                                    onChange={(e) => setListPriceUSD(e.target.value)}

                                />
                            </Grid>
                            <Grid item xs={6}>
                                <BiztranControlsFormik
                                    control='input'
                                    type='text'
                                    label='Net Weight'
                                    name='Weight_kg'
                                    onChange={(e) => setWeight_kg(e.target.value)}

                                />
                            </Grid>
                        </Grid>
                        <Grid spacing={2} container direction="row">
                            <Grid item xs={12}>
                                <div style={{ width: '100%' }}>
                                    <div style={{ display: 'flex', justifyContent: 'center', alignContent: "center" }}>
                                        <BiztranControls.Button
                                            text="SAVE"
                                            type="submit"
                                            startIcon={<SaveIcon />}
                                        />
                                        <BiztranControls.Button
                                            text="CLOSE"
                                            startIcon={<CloseIcon />}
                                            onClick={() => { props.setOpen(false); }}
                                        />
                                    </div>
                                </div>
                            </Grid>
                        </Grid>
                    </Form>
                }}
            </Formik>
        </div>
    );
}

export default CreateProductSKU;
